import { Box, Grid, styled } from "@mui/material";

export const WPArticleItem = styled(Grid)(() => ({
    width: "100%",
    cursor: "pointer",
}));

export const WPArticleItemInnerContainer = styled(Box)(({ theme }) => ({
    background: theme.palette.core.white,
    boxShadow: theme.shadow.boxShadow.sm,
    borderRadius: theme.shape.borderRadius,
}));

export const WPArticleItemImageContainer = styled(Box)(({ theme }) => ({
    background: theme.palette.core.grey._20,
    height: theme.spacing(31),
    position: "relative",
}));

export const WPArticleItemImageInnerContainer = styled(Box)(({ theme }) => ({
    position: "absolute",
    inset: theme.spacing(2),
}));

export const WPArticleItemImage = styled("img")(({ theme }) => ({
    position: "absolute",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    objectFit: "contain",
}));

export const WPArticleItemChip = styled(Box)(({ theme }) => ({
    position: "absolute",
    left: 0,
    top: theme.spacing(2),
    zIndex: 1,
    display: "flex",
    background: "white",
    padding: theme.spacing(1, 2, 1, 2),
    alignItems: "center",
    justifyContent: "center",
    borderTopRightRadius: 20,
    borderBottomRightRadius: 20,
}));

export const WPArticleItemName = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2, 0, 2, 2),
    minHeight: theme.spacing(10),
}));
